import $foreign from "./foreign.cjs";
var bindE = $foreign.bindE;
var forE = $foreign.forE;
var foreachE = $foreign.foreachE;
var pureE = $foreign.pureE;
var untilE = $foreign.untilE;
var whileE = $foreign.whileE;
export { bindE, forE, foreachE, pureE, untilE, whileE };
